<template>
    <el-container style="height:inherit;width:100%;" id="container1">
     <!-- 侧边栏 -->
      <el-aside id="elAside" v-bind:class="{ 'aside-scrollbar':true,activeStyle: isActive, 'text-act': isActives }" >
        <el-scrollbar style="height:100%;">
          <div style="margin:38px 0px 58px 28px;" >
            <img src="../../assets//img/T240319.png" style="width:140px;">
          </div>
          <!-- 菜单 -->
          <side-list></side-list>
        </el-scrollbar> 
      </el-aside>
      <el-container style="height:inherit;width:100%;" id="container2">
        <div style="border:1px solid #ddd;border-radius: 8px;margin:12px 14px;background:#fff;">
          <el-header class="flexs align-items-center" style="justify-content: space-between;">
            <!-- 面包屑 -->
            <div>
              <el-breadcrumb style="font-size:15px;">
                <el-breadcrumb-item v-for="(item,index) in crumbsArrss" :key="index" :to="{ path: item.url }">
                  <i class="el-icon-menu" v-if="index == 0"></i>
                  {{item.name}}
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <!-- 登录姓名 -->
            <div style="justify-content: flex-end;" class="flexs align-items-center">
              <div style="text-align: center;">
                <p class="userTitle">{{realName}}</p>
                <p style="font-size: 12px;color: #666;padding-top: 2px;">{{userName}}</p>
              </div>
              <div class="signOut" @click="signOut()">
                <i class="el-icon-switch-button" style="font-size: 20px;font-weight: 600;"></i>
              </div>
            </div>
          </el-header>
          <!-- tabsViews导航标签页 -->
          <div class="tabsViews">
            <tabsViews/>
          </div>
        </div>
        <el-main id="elMain" style="height:100%;">
          <el-scrollbar style="height:inherit;" class="main-scorllbar">
            <!-- 主体内容 -->
            <div id="mainView" style="height:100%;">
                <transition name="fade-transform" mode="out-in">
                  <keep-alive :include="cachedViews">
                    <router-view ></router-view>
                  </keep-alive>
                </transition>
            </div>
            <!-- 返回顶部 -->
            <el-backtop target="#elMain .el-scrollbar__wrap" :bottom="72" :right="22"></el-backtop>
          </el-scrollbar>
        </el-main>
        <el-footer style="height:42px;"></el-footer>
      </el-container>
      <el-dialog title="退出平台吗？" :visible.sync="SignOut.show" width="580px" :close-on-click-modal="false">
        <div style="font-size:16px;text-align:center;">
          <div><img src="../../assets/img/T240320_1.png" style="width:350px;"></div>
        </div>
        <span slot="footer" class="dialog-footer" >
            <el-button size="mini" icon="el-icon-close" round @click="cancel()">取 消</el-button>
            <el-button size="mini" icon="el-icon-check" round type="primary" @click="handleAdopt('SignOut')">确 定</el-button>
        </span>
      </el-dialog>
    </el-container>
    
</template>

<script>
import SideList from './SideList.vue'
import tabsViews from './tabsViews'
import { mapState,mapActions } from "vuex";
  export default {
    name: 'HelloWorld',
    data () {
      return {
        originalVal:[],
        isCollapse:false,
        isActive:true,
        isActives:false,
        SignOut:{
          show:false,
        }
      }
    },
    components:{
      SideList,tabsViews
    },
    computed:{
      ...mapState({  //比如'movies/hotMovies
        realName: state=>state.realName,
        userName: state=>state.userName,
      }),
      crumbsArrss(){
        let mbx = this.$store.state.crumbsArr;
        return mbx.filter(ele => ele.name);
      },
      cachedViews(){
        return this.$store.state.cachedViews;
      },
    },
    created(){
      //获取用户信息
      this.$api.post(this.API.api + 'home/getLoginUserInfo',{},res=>{
        let param={
          userName:res.data.userName,
          realName:res.data.realName,
          roleId:res.data.roleId,
          roleName:res.data.roleName,
          roleType:res.data.roleType
        }   
        this.saveInfo(param);
      })
    },
    methods:{
      ...mapActions([  //比如'movies/getHotMovies
        'saveInfo',
        'saveMenuWidth'
      ]),
      //(确定))退出
      handleAdopt(){
        this.$api.post(this.API.api + 'home/logOut',{},res=>{
          if(this.$common.getCookie('tibiot-personal-card')){
            document.cookie='tibiot-personal-card='+ this.$common.getCookie('tibiot-personal-card') +';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT';  //清除token
            window.localStorage.removeItem("vuex-along"); //清除vue-along
          }
          this.$router.push("./login");
        })
      },
      //取消
      cancel(){
        this.SignOut.show = false; //弹框关闭
        this.$message.info('已取消操作');
      },
      //退出
      signOut(){
        this.SignOut.show = true;
      },
      //菜单收缩
      operationMenu(){
        let a = document.getElementById('elAside');
        this.isCollapse =!this.isCollapse;
        this.isActive = !this.isActive;
        this.isActives = !this.isActives;
        this.saveMenuWidth({menuWidth:(300 - a.offsetWidth)});
      }
    }
  }
</script>
<style scoped>
#main-header{
  height: 34px !important;
}
#main-header>div{
  font-size:14px !important;
  height: 34px !important;
  line-height: 34px!important;
}
#mainView{
  padding:0px 2px 0px 13px;
}
#elMain{
  padding:2px 0px 0px;
  box-sizing:border-box;
  /* background-color: rgba(255,255,255,.68); */
  margin-right:12px;
}
.el-main {
  color: #666;
}
.signOut{
  font-weight: 700;
  cursor: pointer;
  padding-left:15px;
  color: #222;
}
.signOut:hover{
  color:red;
}
.userTitle{
  font-size: 14px;
  font-weight: 500;
}
#container1 .el-aside{
  height:100% !important;
  padding-left:8px;
  width:232px !important;
  background-color: #ffebff75;
  background-image: linear-gradient(73deg, #ffebff75 0%, #fffbd657 50%, #a3f5ff63 100%);
}
.text-act{
  height:inherit !important;
  width:60px !important;
  transition: width 0.2s;
}
#container2 .el-header{
  height:62px !important;
  border-bottom:1px solid #f5f5f5;
  padding:0px 16px;
}
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all .3s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
<style>
/* 禁止横向滚动条*/
.aside-scrollbar .el-scrollbar__wrap,.main-scorllbar .el-scrollbar__wrap{
  overflow-x: hidden !important;
}


</style>


// WEBPACK FOOTER //
// src/views/components/HelloWorld.vue